/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'timeline': {
    width: 16,
    height: 16,
    viewBox: '0 0 63.61 55',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M36.11.5A26.93 26.93 0 1 1 10 20.63L17.77 31"/><path pid="1" class="cls-2" d="M50.28 12.08l-4.57 4.57M51.07 27.5h6.46M45.7 38.4l4.56 4.56M34.8 42.9v6.45M27.62 37.89l8.15-8.15V11.36"/><path pid="2" class="cls-1" d="M.28 27.27l9.71-6.64"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/timeline.js